import { FC } from "react";
import { StepsProps } from "../../types";
import { FormProvider } from "react-hook-form";
import useStep3 from "./useStep3";
import {
  FormDatePicker,
  FormInput,
  FormPhoneInput,
  FormSectionHeader,
  FormSelect,
  Loader,
} from "@/components";
import {
  ACCOUNT_NUMBER,
  BANK_NAME,
  CURRENCY,
  LEASE_DUE_DATE,
  MONTHLY_DUE_DATE,
  PHONE_1,
  PHONE_2,
  ROUTING_NUMBER,
  YEARLY_DUE_DATE,
} from "./consts";

const Step3: FC<StepsProps> = ({ isView }) => {
  const {
    form,
    requiredFields,
    isFinancialInfoLoading,
    isFinancialInfoRefetching,
    monthlyDateKey,
  } = useStep3();
  const { errors } = form.formState;

  return isFinancialInfoLoading || isFinancialInfoRefetching ? (
    <Loader />
  ) : (
    <FormProvider {...form}>
      <form>
        <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
          <div>
            <FormSectionHeader>Financial and HOA information</FormSectionHeader>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
              <FormDatePicker
                name={YEARLY_DUE_DATE}
                control={form.control}
                label="HOA Yearly Billing Due Date"
                placeholder="Please select"
                error={errors[YEARLY_DUE_DATE]?.message}
                isRequired={requiredFields.includes(YEARLY_DUE_DATE)}
                disabled={isView}
              />
              <FormSelect
                key={monthlyDateKey}
                name={MONTHLY_DUE_DATE}
                control={form.control}
                label="HOA Monthly Billing Due Date"
                placeholder="Please select"
                error={errors[MONTHLY_DUE_DATE]?.message}
                isRequired={requiredFields.includes(MONTHLY_DUE_DATE)}
                disabled={isView}
                options={new Array(31)
                  .fill(0)
                  ?.map((_: number, index: number) => ({
                    label: (index + 1).toString(),
                    value: (index + 1).toString(),
                  }))}
              />
              <FormDatePicker
                name={LEASE_DUE_DATE}
                control={form.control}
                label="HOA Lease Admin Due Date"
                placeholder="Please select"
                error={errors[LEASE_DUE_DATE]?.message}
                isRequired={requiredFields.includes(LEASE_DUE_DATE)}
                disabled={isView}
              />
              <FormInput
                name={CURRENCY}
                control={form.control}
                label="Currency"
                placeholder="Please enter"
                error={errors[CURRENCY]?.message}
                isRequired={requiredFields.includes(CURRENCY)}
                disabled
              />
              <FormInput
                name={BANK_NAME}
                control={form.control}
                label="Bank Name"
                placeholder="Please enter"
                error={errors[BANK_NAME]?.message}
                isRequired={requiredFields.includes(BANK_NAME)}
                disabled={isView}
              />
              <FormInput
                name={ROUTING_NUMBER}
                control={form.control}
                label="Bank Routing Number"
                placeholder="Please enter"
                error={errors[ROUTING_NUMBER]?.message}
                isRequired={requiredFields.includes(ROUTING_NUMBER)}
                disabled={isView}
                variant="integer"
                maxLength={9}
              />
              <FormInput
                name={ACCOUNT_NUMBER}
                control={form.control}
                label="Bank Account Number"
                placeholder="Please select"
                error={errors[ACCOUNT_NUMBER]?.message}
                isRequired={requiredFields.includes(ACCOUNT_NUMBER)}
                disabled={isView}
                variant="integer"
                maxLength={17}
              />
              <FormPhoneInput
                name={PHONE_1}
                control={form.control}
                label="Zelle Phone 1"
                placeholder="Please select"
                error={errors[PHONE_1]?.message}
                isRequired={requiredFields.includes(PHONE_1)}
                disabled={isView}
              />
              <FormPhoneInput
                name={PHONE_2}
                control={form.control}
                label="Zelle Phone 2"
                placeholder="Please select"
                error={errors[PHONE_2]?.message}
                isRequired={requiredFields.includes(PHONE_2)}
                disabled={isView}
              />
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default Step3;
